import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.')
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    // ✅ 触发全局事件，通知 App.vue 显示更新提示
    updated() {
      window.dispatchEvent(new CustomEvent('sw-updated'))
    },
    offline() {
      console.log('No internet connection found.')
    },
    error(error) {
      console.error('SW registration error:', error)
    }
  })
}